import SvgIcon, { SvgIconProps } from 'LuxKit/SvgIcon'

function LineMoneyBillSlashIcon(props: SvgIconProps) {
  return <SvgIcon {...props} fill="none" viewBox="0 0 24 24">
    <path fill="currentColor" d="M6 11a1.0006 1.0006 0 0 0-.9239.6173A1 1 0 1 0 6 11Zm5.86-1.55L4.71 2.29a1.0041 1.0041 0 1 0-1.42 1.42L4.59 5H4a3 3 0 0 0-3 3v8a2.9998 2.9998 0 0 0 3 3h14.59l2.7 2.71a.9997.9997 0 0 0 1.42 0 .9997.9997 0 0 0 0-1.42L11.86 9.45Zm-.74 2.09 1.34 1.34A.9994.9994 0 0 1 12 13a1.0001 1.0001 0 0 1-1-1 .9997.9997 0 0 1 .12-.46ZM4 17a1.0002 1.0002 0 0 1-1-1V8a1 1 0 0 1 1-1h2.59l3.1 3.1A2.9999 2.9999 0 0 0 9 12a2.9998 2.9998 0 0 0 3 3 2.9998 2.9998 0 0 0 1.9-.69L16.59 17H4ZM20 5h-7.34a1 1 0 1 0 0 2H20a1 1 0 0 1 1 1v7.34a1.0001 1.0001 0 0 0 2 0V8a3 3 0 0 0-3-3Zm-1 7a1 1 0 1 0-2-.0002A1 1 0 0 0 19 12Z"/>
  </SvgIcon>
}

export default LineMoneyBillSlashIcon
